import { render, staticRenderFns } from "./mallclassSelect.vue?vue&type=template&id=4e02d076"
import script from "./mallclassSelect.vue?vue&type=script&lang=js"
export * from "./mallclassSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports